// @ts-check
// src/stores/after-sales.js — Sesja 3.6 — After-Sales state in Nanostores

import { atom } from 'nanostores';

/** Lista spraw posprzedażowych (cases) */
export const $afterSalesCases = atom(/** @type {any[]} */ ([]));

/** Filtry listy after-sales (search/status/type itd.) */
export const $afterSalesFilters = atom(/** @type {Record<string, any>} */ ({}));

/** Aktualna strona */
export const $afterSalesPage = atom(1);

/** Liczba rekordów na stronę */
export const $afterSalesPerPage = atom(20);

/** Łączna liczba rekordów */
export const $afterSalesTotal = atom(0);

/** Łączna liczba stron */
export const $afterSalesPages = atom(1);

/** Wybrane konto (id lub 'all' lub 0) */
export const $afterSalesAccountId = atom(/** @type {any} */ (0));

/** Status synchronizacji Allegro after-sales */
export const $afterSalesSyncStatus = atom(/** @type {any} */ (null));

if (typeof window !== 'undefined') {
  /** @type {any} */ (window).__sbStores = Object.assign(/** @type {any} */ (window).__sbStores || {}, {
    $afterSalesCases,
    $afterSalesFilters,
    $afterSalesPage,
    $afterSalesPerPage,
    $afterSalesTotal,
    $afterSalesPages,
    $afterSalesAccountId,
    $afterSalesSyncStatus,
  });
}
